function initActivity(){
    initSelectize();
    initSelectizeAjax();
    initTypeaheadAjax();
    initDatePicker();
    initTimePicker();

    initActivityButtons();

   // var finished = $('#activity-form #status:checked').val();

    $('#activity-form #status').change(function(){
        if($(this).is(':checked')){
            $('#finished-action').show();
        }else{
            $('#finished-action').hide();
        }
    });


    $('#activity-form #alert').change(function(){
        if($(this).is(':checked')){
            $('#notify-action').show();
        }else{
            $('#notify-action').hide();
        }
    });



    $('#activity-form #status').trigger('change');
    $('#activity-form #alert').trigger('change');


    if ($('#activity-form input[name="id"]').val()== '' ){

    }



        $('#activity-form #duration').on('change', function(){
            $(this).removeClass('pristine');
        });

        $('#activity-form .btn-group .btn').on('click', function () {
            if ($(this).attr('data-duration') != undefined && $('#activity-form #duration').hasClass('pristine')) {
                $('#activity-form #duration').val($(this).attr('data-duration'));
            }
        })


}

function initActivityButtons(){


    $('#saveAction').click(function(){

        var target = $(this).attr('data-targetform');
        var $target = $(target);
        var l = Ladda.create(this);
        l.start();

        $.post($target.attr('action'), $target.serialize())
            .done(function(data){
                if (data.status){
                    //$('#filter').trigger('filter:refresh');
                    $('body').trigger('activity:added');
                    $('.slidePanel-close').trigger('click');
                }else{
                    window.errorsCheck(data);
                }

            })
            .always(function() { l.stop(); });



    });

}